import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { mapLanguageToComponentProps } from 'admin/i18n'
import { CandidateStage } from 'components/styled/candidate-stage'
import { getStageTypeAndCustomStage } from 'utils/stage'
import { StageType } from 'types'
import { I18nComponentType } from 'admin/i18n-types'
import { CandidateStages } from 'components/styled/icon/candidate-stage/stage-icon'

interface StageContentProps {
  stage?: StageType
  positionStages?: StageType[]
  i18n: I18nComponentType
  wrapping?: boolean
}

const StageContent = ({
  stage,
  positionStages,
  wrapping = false,
  i18n,
}: StageContentProps) => {
  if (stage) {
    const { stageType, customStage } = getStageTypeAndCustomStage(
      stage,
      positionStages,
      i18n.searchFilter.status
    )
    return (
      <CandidateStage
        stage={stageType}
        customStage={customStage}
        wrapping={wrapping}
      />
    )
  }

  return <CandidateStage stage={CandidateStages.New} />
}

export default connect<{
  i18n: I18nComponentType
}>(mapLanguageToComponentProps())(StageContent)
